module.exports = __webpack_public_path__ + "static/media/es.a66f5888.svg";